module.exports = __webpack_public_path__ + "img/south-sudan.76f955c8.svg";